/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */
/* eslint-disable react/prop-types */

import { useCallback, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { DateActionTypes } from 'reporting-ui-components/constants/trackingConstants';
import { EVENTS } from 'reporting-ui-components/lib/events';
import useCloneTracker from 'reporting-ui-components/lib/useCloneTracker';
import { isFailed, isLoading, isSucceeded } from 'reporting-data/asyncData/AsyncData';
import BaseSelectEditorComponent from '../common/BaseSelectEditorComponent';
import useFetchOptionsForBaseMetricEditor from './useFetchOptionsForBaseMetricEditor';
import { jsx as _jsx } from "react/jsx-runtime";
const MetricEditorLabel = /*#__PURE__*/_jsx(FormattedMessage, {
  message: "settingLabels.metric.dropdownLabel"
});
export const BaseMetricEditor = props => {
  const {
    appUsageTracker,
    isV2FilterExperience,
    onChange,
    report,
    schema: editorSchema,
    strategy: editorStrategy,
    trackingApplicationName,
    trackingAssetType,
    trackingScreenName
  } = props;
  const dataType = editorStrategy.getDataType(report);
  const usageTracker = useCloneTracker(appUsageTracker);
  const propertyOptionFetch = useFetchOptionsForBaseMetricEditor(dataType, editorSchema);
  const propertyOptions = useMemo(() => {
    return isSucceeded(propertyOptionFetch) ? propertyOptionFetch.data : [];
  }, [propertyOptionFetch]);
  const selectionLimit = useMemo(() => editorStrategy.getSelectionLimit(report), [editorStrategy, report]);
  const isMultiSelect = selectionLimit > 1;
  const selectedMetrics = useMemo(() => {
    const currentValues = editorStrategy.getCurrentValue(report);
    return isMultiSelect ? currentValues : currentValues[0];
  }, [editorStrategy, report, isMultiSelect]);
  const handleChange = useCallback(({
    target: {
      value: newMetrics
    }
  }) => {
    if (isMultiSelect && selectionLimit && selectionLimit < newMetrics.length) {
      return;
    }
    const isMultiValue = Array.isArray(newMetrics);
    const updatedMetrics = newMetrics ? isMultiValue ? newMetrics : [newMetrics] : [];
    if (isMultiValue && updatedMetrics.length === 0 && propertyOptions.length) {
      updatedMetrics.push(propertyOptions[0].value);
    }
    usageTracker.track(EVENTS.changeSrvDateFilters, {
      action: DateActionTypes.METRIC,
      assetType: trackingAssetType || 'report',
      whereScreen: trackingScreenName,
      applicationName: trackingApplicationName,
      isNewFilterExperience: isV2FilterExperience
    });
    onChange(editorStrategy.updateReport(report, updatedMetrics));
  }, [editorStrategy, isMultiSelect, isV2FilterExperience, onChange, propertyOptions, report, selectionLimit, trackingApplicationName, trackingAssetType, trackingScreenName, usageTracker]);
  if (isSucceeded(propertyOptionFetch) && propertyOptions.length === 0 || isFailed(propertyOptionFetch)) {
    return null;
  }
  const metricLimitTooltip = isMultiSelect && selectionLimit === selectedMetrics.length ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "settingLabels.metric.metricLimitTooltip",
    options: {
      limit: selectionLimit
    }
  }) : null;
  if (isV2FilterExperience) {
    return /*#__PURE__*/_jsx(BaseSelectEditorComponent, {
      tooltipHeader: MetricEditorLabel,
      options: propertyOptions,
      value: selectedMetrics,
      multi: isMultiSelect,
      multiCollapseLimit: 5,
      searchable: true,
      onChange: handleChange,
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "settingLabels.metric.placeholder"
      }),
      tooltipText: metricLimitTooltip
    });
  }
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: MetricEditorLabel,
    tooltip: metricLimitTooltip,
    children: isLoading(propertyOptionFetch) ? /*#__PURE__*/_jsx(UILoadingSpinner, {
      size: "xs"
    }) : /*#__PURE__*/_jsx(UISelect, {
      anchorType: "button",
      "data-test-id": "report-editor-metric-editor",
      options: propertyOptions,
      searchable: true,
      multi: isMultiSelect,
      multiCollapseLimit: 5,
      value: selectedMetrics,
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "settingLabels.metric.placeholder"
      }),
      onChange: handleChange
    })
  });
};